import {combineReducers} from "redux";
import companyUsers from './companyUsers';

export default combineReducers({ companyUsers });
